// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ApplicationInfo } from '@shared/commons/ApplicationInfo';
import { Resources } from '@shared/localizations/Resources';
import TerceraBaseWindowTemplate from '@front/templates/TerceraBaseWindowTemplate.html';
import TerceraAboutScreenTemplate from '@front/templates/TerceraAboutScreenTemplate.html';
import { TerceraWindowBase } from './TerceraWindowBase';
// constructor
export class TerceraAboutScreen extends TerceraWindowBase {
    constructor() {
        super();
    }
    getType() {
        return 'TerceraAboutScreen';
    }
    oncomplete() {
        super.oncomplete();
        this.updateBrandingImage();
        this.localize();
        this.center();
    }
    localize() {
        let version = 'Not found';
        let date = 'Not found';
        if (!isNullOrUndefined(ApplicationInfo.BuildVersionData)) {
            version = ApplicationInfo.BuildVersionData.toString();
            date = ApplicationInfo.BuildVersionData.dateDay;
        }
        void this.set({
            header: document.title === 'web'
                ? Resources.getResource('screen.about.titleWeb')
                : Resources.getResource('screen.about.title') + ' ' + document.title,
            copyrightText: Resources.getResource('screen.about.copyright'),
            versionText: Resources.getResource('screen.about.versionWeb') + ' ' + version,
            buildDateText: Resources.getResource('screen.about.dateBuild') + ' ' + date,
            isHiddenCopyrightText: Resources.isHidden('screen.about.copyright')
        });
    }
}
TerceraWindowBase.extendWith(TerceraAboutScreen, {
    template: TerceraBaseWindowTemplate,
    data: function () {
        return {
            movable: true,
            showHeader: true,
            showFooter: false,
            resizable: false,
            canSelect: false,
            // alwaysMiddle: true,  // #89762
            focused: true,
            showFullscreenCloud: true,
            width: 400,
            height: 400,
            versionText: 'Build version: 3.1312',
            buildDateText: 'Date of build: 13.12.2013 11:12:13',
            copyrightText: '2017-2026 TraderEvolution Global LTD.',
            style_addition_header: 'about-screen-addition-header',
            isHiddenCopyrightText: false
        };
    },
    partials: { bodyPartial: TerceraAboutScreenTemplate }
});
